import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=eccbeda0&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Switch.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Switch.vue
// module id = null
// module chunks = 